import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pointer",
  "use": "icon-pointer-usage",
  "viewBox": "0 0 1036 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1036 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pointer\"><path d=\"M1036.8 447.744L572.928 565.76 453.888 1024 0 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol